module.exports = __webpack_public_path__ + "static/media/theater.e8b018d8.svg";